import React from 'react';
import './Extrusionmolding.css';
import Extrubl from '../../../imgs/Extrublow.webp';


const Extrusionmolding = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">EB10H Extrusion Blow Molding Machine K 2022 Exhibition Model</h2>
                <p className="Material-date">Sep. 28, 2022</p>
                <div className="advantpl">
                    <img src={Extrubl} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                <p className="Material-text">Disha automatic extrusion blow molding machines have lower total power 
                    and lower energy consumption than the same screw models.</p>
                <p className="Material-text"> In addition, the center of gravity of the machine is relatively 
                    low, and the speed reduction valve brake is used to move the mold 
                    so that the machine can move relatively 
                    quickly and smoothly, and the productivity per hour is higher</p>
                <p className="Material-text">In comprehensive comparison, Powerjet blowing
                     equipment has obvious advantages in income and performance.</p>
            </div>
        </div>
    );
};
export default Extrusionmolding;
